export default "__VITE_ASSET__85d7c89f__"